export default __webpack_public_path__ + "static/thriftbooks-7abca71c5f02636211a22176467f3b01.png";